// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "./Grpc.js";
import * as Buhta_core__GrpcState from "./GrpcState.js";
import * as Buhta_core__Request from "./Request.js";
import * as Buhta_models__AuthIdp from "../../models/AuthIdp.js";
import * as Buhta_platformapis__Buhta_idp_v1_profile_service from "../../../proto/platformapis/gen/buhta_idp_v1_profile_service.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../vendored/promise/promise.js";
import * as ReasonReactUpdate from "../../../vendored/reason-react-update/ReasonReactUpdate.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";

function fetchFlow(flowTypeOpt, flow, cookie) {
  const flowType = flowTypeOpt !== undefined ? flowTypeOpt : "login";
  const headers = new Headers({
        Accept: "application/json",
        Cookie: cookie
      });
  return Buhta_core__Request.get(Caml_option.some(headers), Buhta_models__AuthIdp.KratosFlow.decode, undefined, "/.idp/self-service/" + flowType + "/flows?id=" + flow);
}

function getError(error, cookie) {
  const headers = new Headers({
        cookie: cookie
      });
  return Buhta_core__Request.get(Caml_option.some(headers), Buhta_models__AuthIdp.KratosFlow.decodeError, undefined, "/.idp/self-service/errors?id=" + error);
}

const Kratos = {
  fetchFlow: fetchFlow,
  getError: getError
};

function logout(param) {
  return Buhta_core__Request.post(undefined, undefined, (function (param) {
                return "";
              }), "/logout", null);
}

function fetchIdentityProfile(token, param) {
  const request = Curry._2(Buhta_platformapis__Buhta_idp_v1_profile_service.Buhta.Idp.V1.GetProfileRequest.make, {
        hd: "tenants",
        tl: /* [] */0
      }, undefined);
  const headers = Belt__Belt_Option.map(token, (function (tkn) {
          return new Headers({
                      Cookie: "bis_id_session=" + tkn
                    });
        }));
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                const profile = response.profile;
                if (profile !== undefined) {
                  return profile;
                } else {
                  return Stdlib.failwith("Empty profile data received");
                }
              }), Buhta_core__Grpc.makeRpc(request, Buhta_platformapis__Buhta_idp_v1_profile_service.Buhta.Idp.V1.ProfileService.getProfile, headers, undefined, undefined, Buhta_platformapis__Buhta_idp_v1_profile_service.Buhta.Idp.V1.ProfileService.GetProfile.name, undefined, undefined));
}

function initValue_1(param) {
  
}

const initValue = [
  /* Guest */0,
  initValue_1
];

const context = React.createContext(initValue);

function useIdentity(param) {
  return React.useContext(context);
}

const IdentityContext = {
  initValue: initValue,
  context: context,
  useIdentity: useIdentity
};

const make = context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

const IdentityProvider = {
  make: make,
  makeProps: makeProps
};

function getInitialIdentity(prefetched, identity) {
  if (identity !== undefined) {
    return {
            TAG: /* Authorized */0,
            _0: identity
          };
  } else if (prefetched) {
    return /* Guest */0;
  } else {
    return /* Loading */1;
  }
}

function useAuthContext(initialIdentity) {
  const match = ReasonReactUpdate.useReducer(initialIdentity, (function (action, param) {
          if (typeof action === "number") {
            return {
                    TAG: /* UpdateWithSideEffects */1,
                    _0: /* Loading */1,
                    _1: (function (param) {
                        const send = param.send;
                        const __x = fetchIdentityProfile(undefined, undefined);
                        $$Promise.get(__x, (function (result) {
                                if (result.TAG === /* Ok */0) {
                                  return Curry._1(send, {
                                              TAG: /* IdentityReady */0,
                                              _0: result._0
                                            });
                                }
                                console.log("user loading failure", result._0);
                              }));
                      })
                  };
          }
          switch (action.TAG | 0) {
            case /* IdentityReady */0 :
                return {
                        TAG: /* UpdateWithSideEffects */1,
                        _0: {
                          TAG: /* Authorized */0,
                          _0: action._0
                        },
                        _1: (function (param) {
                            
                          })
                      };
            case /* IdentityAuthenticated */1 :
                const onSignedIn = action._1;
                return {
                        TAG: /* UpdateWithSideEffects */1,
                        _0: {
                          TAG: /* Authorized */0,
                          _0: action._0
                        },
                        _1: (function (param) {
                            Curry._1(onSignedIn, undefined);
                          })
                      };
            case /* IdentitySignedOut */2 :
                const onSignedOut = action._0;
                return {
                        TAG: /* UpdateWithSideEffects */1,
                        _0: /* Guest */0,
                        _1: (function (param) {
                            Curry._1(onSignedOut, undefined);
                          })
                      };
            
          }
        }));
  const dispatchAuth = match[1];
  const identity = match[0];
  React.useEffect((function () {
          if (Caml_obj.caml_equal(identity, /* Loading */1)) {
            Curry._1(dispatchAuth, /* IdentityRequested */0);
          }
          
        }), []);
  return [
          identity,
          dispatchAuth
        ];
}

export {
  Kratos ,
  logout ,
  fetchIdentityProfile ,
  IdentityContext ,
  IdentityProvider ,
  getInitialIdentity ,
  useAuthContext ,
}
/* context Not a pure module */
